export default {
      id: "trash-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#trash",
      toString: function () {
        return this.url;
      }
    }